var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 0H3.9375C1.76288 0 0 1.76288 0 3.9375V14.0625C0 16.2371 1.76288 18 3.9375 18H14.0625C16.2371 18 18 16.2371 18 14.0625V3.9375C18 1.76288 16.2371 0 14.0625 0Z",
    fill: "#D0313C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.75H0V14.2526H18V3.75Z",
    fill: "#FFD048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84173 9.0131L8.13194 7.82957C8.15866 7.72058 8.06715 7.61719 7.94396 7.61719H7.73953C7.61634 7.61719 7.52479 7.72058 7.55155 7.82957L7.84173 9.0131Z",
    fill: "#D0313C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1846 8.39453H7.5V11.0313H8.1846V8.39453Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35504 8.08203H7.32812V8.39221H8.35504V8.08203Z",
    fill: "#FAB446"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35597 9.01562H6.64453V9.32581H8.35597V9.01562Z",
    fill: "#D0313C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.355 10.2571L7.32812 9.9469V9.63672L8.355 9.9469V10.2571Z",
    fill: "#D0313C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70891 9.01701L2.99913 7.83347C3.02585 7.72449 2.93434 7.62109 2.81115 7.62109H2.60671C2.48353 7.62109 2.39198 7.72449 2.41873 7.83347L2.70891 9.01701Z",
    fill: "#D0313C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90478 8.08203C3.71575 8.08203 3.5625 8.2209 3.5625 8.39225V10.4086C3.5625 10.7855 3.95066 11.4943 5.27398 11.4943C6.59729 11.4943 6.98545 10.7854 6.98545 10.4086V8.39225C6.98545 8.22093 6.83221 8.08203 6.64317 8.08203H3.90478Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27788 9.63696H3.56641V8.4118C3.56641 8.23184 3.7123 8.08594 3.89227 8.08594H5.27788V9.63696Z",
    fill: "#D0313C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27734 9.63672H6.98882V10.3731C6.98882 10.823 6.62411 11.1877 6.17418 11.1877H6.09198C5.64209 11.1877 5.27734 10.823 5.27734 10.3731V9.63672Z",
    fill: "#D0313C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 9.63672H5.27398V10.3731C5.27398 10.823 4.90927 11.1877 4.45934 11.1877H4.37714C3.92725 11.1877 3.5625 10.823 3.5625 10.3731C3.5625 10.3731 3.5625 9.63672 3.5625 9.63672Z",
    fill: "#FAB446"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93212 11.0252V9.63281H4.58984V11.1682C4.71711 11.1447 4.83218 11.0937 4.93212 11.0252Z",
    fill: "#D0313C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24853 11.1682V9.63281H3.90625V11.0252C4.0062 11.0937 4.12123 11.1447 4.24853 11.1682Z",
    fill: "#D0313C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93316 9.01562H3.90625V9.32581H4.93316V9.01562Z",
    fill: "#FFB441"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93316 8.39453H3.90625V8.70475H4.93316V8.39453Z",
    fill: "#FAB446"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76272 8.57812H4.07812V9.1401H4.76272V8.57812Z",
    fill: "#FAB446"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05179 8.39453H2.36719V11.0313H3.05179V8.39453Z",
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22223 10.8789H2.19531V11.1891H3.22223V10.8789Z",
    fill: "#FAB446"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22223 8.08594H2.19531V8.39612H3.22223V8.08594Z",
    fill: "#FAB446"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3926 11.1875H2.02344V11.4977H3.3926V11.1875Z",
    fill: "#5064AA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52691 10.875H7.5V11.1852H8.52691V10.875Z",
    fill: "#FAB446"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52932 11.1875H7.16016V11.4977H8.52932V11.1875Z",
    fill: "#5064AA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30383 7.77344H4.25V8.08362H6.30383V7.77344Z",
    fill: "#FAB446"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44775 6.84375H5.10547V7.77437H5.44775V6.84375Z",
    fill: "#FFB441"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9353 7.30559C4.65218 7.30559 4.42188 7.09686 4.42188 6.84029C4.42188 6.58372 4.65218 6.375 4.9353 6.375C5.21841 6.375 5.44872 6.58372 5.44872 6.84029C5.44872 7.09686 5.21841 7.30559 4.9353 7.30559ZM4.9353 6.68518C4.84087 6.68518 4.76416 6.75472 4.76416 6.84029C4.76416 6.92586 4.84087 6.9954 4.9353 6.9954C5.02973 6.9954 5.10644 6.92586 5.10644 6.84029C5.10644 6.75472 5.02973 6.68518 4.9353 6.68518Z",
    fill: "#F5F5F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6228 7.30559C5.33968 7.30559 5.10938 7.09686 5.10938 6.84029C5.10938 6.58372 5.33968 6.375 5.6228 6.375C5.90591 6.375 6.13622 6.58372 6.13622 6.84029C6.13622 7.09686 5.90595 7.30559 5.6228 7.30559ZM5.6228 6.68518C5.52837 6.68518 5.45166 6.75472 5.45166 6.84029C5.45166 6.92586 5.52837 6.9954 5.6228 6.9954C5.71723 6.9954 5.79394 6.92586 5.79394 6.84029C5.79394 6.75472 5.71723 6.68518 5.6228 6.68518Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30639 7.61418C6.02328 7.61418 5.79297 7.40546 5.79297 7.14889C5.79297 6.89232 6.02328 6.68359 6.30639 6.68359C6.5895 6.68359 6.81985 6.89232 6.81985 7.14889C6.81985 7.40546 6.5895 7.61418 6.30639 7.61418ZM6.30639 6.99378C6.21196 6.99378 6.13525 7.06332 6.13525 7.14889C6.13525 7.23446 6.21196 7.304 6.30639 7.304C6.40082 7.304 6.47753 7.23446 6.47753 7.14889C6.47753 7.06328 6.40082 6.99378 6.30639 6.99378Z",
    fill: "#F5F5F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2517 7.61418C3.96859 7.61418 3.73828 7.40546 3.73828 7.14889C3.73828 6.89232 3.96859 6.68359 4.2517 6.68359C4.53482 6.68359 4.76513 6.89232 4.76513 7.14889C4.76513 7.40546 4.53482 7.61418 4.2517 7.61418ZM4.2517 6.99378C4.15727 6.99378 4.08056 7.06332 4.08056 7.14889C4.08056 7.23446 4.15727 7.304 4.2517 7.304C4.34613 7.304 4.42284 7.23446 4.42284 7.14889C4.42284 7.06328 4.34613 6.99378 4.2517 6.99378Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30179 10.2555V10.4106C6.30179 10.4962 6.225 10.5658 6.13064 10.5658C6.03629 10.5658 5.9595 10.4962 5.9595 10.4106V10.2555H6.30179ZM6.64407 9.94531H5.61719V10.4106C5.61719 10.6672 5.84753 10.8759 6.13061 10.8759C6.41372 10.8759 6.64407 10.6671 6.64407 10.4106V9.94531Z",
    fill: "#FAB446"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1478 9.32515H6.11493C5.93496 9.32515 5.78906 9.17925 5.78906 8.99929V8.72039C5.78906 8.54043 5.93496 8.39453 6.11493 8.39453H6.1478C6.32776 8.39453 6.47366 8.54043 6.47366 8.72039V8.99929C6.47366 9.17929 6.32776 9.32515 6.1478 9.32515Z",
    fill: "#FFA0D2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27514 10.0986C5.5587 10.0986 5.78856 9.89024 5.78856 9.63326C5.78856 9.37629 5.5587 9.16797 5.27514 9.16797C4.99159 9.16797 4.76172 9.37629 4.76172 9.63326C4.76172 9.89024 4.99159 10.0986 5.27514 10.0986Z",
    fill: "#5064AA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44775 6.22266H5.10547V7.15328H5.44775V6.22266Z",
    fill: "#FAB446"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24853 7.77437L3.90625 7.46415L4.10675 7.28243C4.41668 7.00153 4.83708 6.84375 5.27541 6.84375C5.71374 6.84375 6.13414 7.00157 6.44407 7.28243L6.64457 7.46415L6.30229 7.77437H4.24853Z",
    fill: "#D0313C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2727 7.61881C5.36722 7.61881 5.44384 7.54937 5.44384 7.4637C5.44384 7.37804 5.36722 7.30859 5.2727 7.30859C5.17819 7.30859 5.10156 7.37804 5.10156 7.4637C5.10156 7.54937 5.17819 7.61881 5.2727 7.61881Z",
    fill: "#FFD250"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58911 7.61881C4.68363 7.61881 4.76025 7.54937 4.76025 7.4637C4.76025 7.37804 4.68363 7.30859 4.58911 7.30859C4.49459 7.30859 4.41797 7.37804 4.41797 7.4637C4.41797 7.54937 4.49459 7.61881 4.58911 7.61881Z",
    fill: "#FFD250"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9563 7.61881C6.05082 7.61881 6.12744 7.54937 6.12744 7.4637C6.12744 7.37804 6.05082 7.30859 5.9563 7.30859C5.86178 7.30859 5.78516 7.37804 5.78516 7.4637C5.78516 7.54937 5.86178 7.61881 5.9563 7.61881Z",
    fill: "#FFD250"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90675 9.01172H2.19531V9.3219H3.90675V9.01172Z",
    fill: "#D0313C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19531 10.2532L3.22219 9.943V9.63281L2.19531 9.943V10.2532Z",
    fill: "#D0313C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsFlag);
export default __webpack_public_path__ + "static/media/ES_Flag.af54ddb873580c2ffb6f3bc72666e54a.svg";
export { ForwardRef as ReactComponent };